import { takeLatest, call, put } from 'redux-saga/effects';
import {
  GET_ESTIMATED_EARNINGS_GRAPH_DATA,
  SET_ESTIMATED_EARNINGS_GRAPH_DATA,
} from '../redux/action/types';
import { areaApi } from '../utils/api';

function* getEstimatedEarningsGraphData(action) {
  try {
    const response = yield call(() => areaApi.getEstimatedEarningsGraphData(action.data));
    yield put({ type: SET_ESTIMATED_EARNINGS_GRAPH_DATA, payload: response.data.data });
  } catch (err) {
    action.data.onError && action.data.onError();
    console.log(err);
  }
}

function* estimatesSaga() {
  yield takeLatest(GET_ESTIMATED_EARNINGS_GRAPH_DATA, getEstimatedEarningsGraphData);
}

export default estimatesSaga;
